/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `slave_device` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class SlaveDeviceMesg : Mesg {
    public constructor() : super("SlaveDevice", Profile.MesgNum.SLAVE_DEVICE)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** manufacturer. */
    public var manufacturer: Manufacturer?
        get() = (getFieldValue(MANUFACTURER_FIELD_NUM) as? UShort)?.let { Manufacturer.fromValue(it) }
        set(value) = setFieldValue(MANUFACTURER_FIELD_NUM, value?.value)

    /** product. */
    public var product: UShort?
        get() = getFieldValue(PRODUCT_FIELD_NUM) as? UShort
        set(value) = setFieldValue(PRODUCT_FIELD_NUM, value)

    /**
     * favero_product: what product means when this message selects it.
     */
    public val faveroProduct: FaveroProduct?
        get() = (getFieldValue(PRODUCT_FIELD_NUM, 0, SubFieldSelector.Named("FaveroProduct")) as? UShort)?.let { FaveroProduct.fromValue(it) }

    public fun setFaveroProduct(value: FaveroProduct?) {
        setFieldValue(PRODUCT_FIELD_NUM, value?.value, 0, SubFieldSelector.Named("FaveroProduct"))
    }

    /**
     * garmin_product: what product means when this message selects it.
     */
    public val garminProduct: GarminProduct?
        get() = (getFieldValue(PRODUCT_FIELD_NUM, 0, SubFieldSelector.Named("GarminProduct")) as? UShort)?.let { GarminProduct.fromValue(it) }

    public fun setGarminProduct(value: GarminProduct?) {
        setFieldValue(PRODUCT_FIELD_NUM, value?.value, 0, SubFieldSelector.Named("GarminProduct"))
    }

    public companion object {
        public const val MANUFACTURER_FIELD_NUM: UByte = 0u
        public const val PRODUCT_FIELD_NUM: UByte = 1u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[0] = Field("Manufacturer", 0u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[1] = Field("Product", 1u, BaseType.UINT16, 1.0, 0.0, "", false)
                .addSubField(
                    SubField("FaveroProduct", BaseType.UINT16, 1.0, 0.0, "").also { subField ->
                        subField.addMap(0u, 263)
                    },
                )
                .addSubField(
                    SubField("GarminProduct", BaseType.UINT16, 1.0, 0.0, "").also { subField ->
                        subField.addMap(0u, 1)
                        subField.addMap(0u, 15)
                        subField.addMap(0u, 13)
                        subField.addMap(0u, 89)
                    },
                )
            return fields
        }
    }
}
